<template>
  <b-modal
    :visible="visible"
    :title="modalTitle"
    size="xl"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('close')"
  >
    <div class="row mb-5">
      <div class="col-md-10 mt-3">
        <label>Nombre parámetro</label>
        <input
          class="form-control"
          v-model="name"
          placeholder="Nombre del parámetro"
        >
      </div>
      <div class="col-md-2 mt-3 text-right">
        <feather-icon
          v-tooltip="'Agregar parámetro'"
          color="green"
          size="18"
          icon="PlusCircleIcon"
          @click="addSubParameter"
        />
      </div>

      <div class="col-md-12 mt-3">
        <div class="grid-striped">
          <ul class="list-group mt-5">
            <draggable
              :group="{ name: 'paramList' }"
              class="cursor-move"
              v-model="parameters"
            >
              <li
                v-for="(param, index) in parameters"
                :key="'param-' + index"
                :id="'param-' + index"
                class="list-group-item"
              >
                <ParameterItem
                  :param="param"
                  :is-editing="param.inEdit"
                  @delete="deleteSubParameter(index)"
                  @toggle-edit="toggleEdit(index, $event)"
                  @update="updateSubParameter(index, $event)"
                />
              </li>
            </draggable>
          </ul>
        </div>
      </div>

      <div class="col-md-12 mt-3">
        <div
          v-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>
        <div style="float: right">
          <vs-button
            class="action"
            color="primary"
            type="border"
            icon="save"
            :disabled="isSaving"
            @click="save"
          >
            {{ isSaving ? 'Guardando...' : 'Guardar' }}
          </vs-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import draggable from 'vuedraggable';
import ParameterItem from './ParameterItem.vue';
import { saveParameter } from '@/febos/global/empresas/servicios/configParams.service';

export default {
  name: 'ParameterModal',
  components: {
    draggable,
    ParameterItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    parameter: {
      type: Object,
      default: null
    },
    parentId: {
      type: String,
      default: null
    },
    childrenCount: {
      type: Number,
      default: 0
    },
    isCopy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      parameters: [],
      isSaving: false,
      error: null
    };
  },
  computed: {
    modalTitle() {
      if (this.isEditMode) return 'Editar parámetro';
      if (this.isCopy) return 'Copiar parámetro';
      return 'Nuevo parámetro';
    },
    isEditMode() {
      return !!(this.parameter && this.parameter.optionId && !this.isCopy);
    }
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.initForm();
      }
    }
  },
  methods: {
    initForm() {
      this.error = null;
      this.isSaving = false;

      if (this.parameter) {
        this.name = this.parameter.name || '';
        const params = this.parameter.extra?.parameters || this.parameter.parameters || [];
        this.parameters = params.map(p => ({ ...p, inEdit: false }));
      } else {
        this.name = '';
        this.parameters = [];
      }
    },
    addSubParameter() {
      this.parameters.push({ inEdit: true });
    },
    deleteSubParameter(index) {
      this.parameters.splice(index, 1);
    },
    toggleEdit(index, isEditing) {
      this.$set(this.parameters, index, {
        ...this.parameters[index],
        inEdit: isEditing
      });
    },
    updateSubParameter(index, updatedParam) {
      this.$set(this.parameters, index, {
        ...updatedParam,
        inEdit: this.parameters[index].inEdit
      });
    },
    async save() {
      this.error = null;
      this.isSaving = true;

      try {
        const cleanedParameters = this.parameters.map(({ inEdit, ...rest }) => rest);

        const data = {
          name: this.name,
          parameters: cleanedParameters
        };

        if (this.isEditMode) {
          data.optionId = this.parameter.optionId;
          data.parameterId = this.parameter.parameterId;
        } else {
          data.parentId = this.parentId;
          data.order = this.childrenCount + 1;
        }

        await saveParameter(data);
        this.$emit('save');
      } catch (err) {
        this.error = err.message || 'Error al guardar el parámetro';
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>
